import React from 'react';
import { ImmutableRootState } from '@uncinc/react-drupal-core/types';
import { useSelector } from 'react-redux';
import Dropdown from '../Dropdown';
import { DEFAULT_LANGUAGE, LANGUAGES } from '../../config/constants';
import useAriaDisclosure from '../../hooks/useAriaDisclosure';
import useClasses from '../../hooks/useClasses';
import useTypedDispatch from '../../hooks/useTypedDispatch';
import { setLanguage } from '../../store/actions/UI';

import './style.scss';

const LANGUAGE_SWITCHER_ID = 'LanguageOptions';

const LanguageSwitcher: React.FC = () => {
  const {
    buildClass,
    joinClasses,
  } = useClasses('LanguageSwitcher');

  const currentLanguage = useSelector<ImmutableRootState<string>, string>((state) => state.getIn(['ui', 'language'], DEFAULT_LANGUAGE));

  const disclosure = useAriaDisclosure<HTMLDivElement>(LANGUAGE_SWITCHER_ID, {
    closeOnEscape: true,
    closeOnOutsideClick: true,
  });

  const dispatch = useTypedDispatch();

  function onLanguageChange(langcode: string) {
    dispatch(setLanguage(langcode));

    if (disclosure.isOpen) {
      disclosure.toggleIsOpen();
    }
  }

  return (
    <div className={buildClass()}>
      <button
        type="button"
        className={joinClasses(buildClass('dropdown-trigger'), 'MenuMainItem icon-after icon-chevron icon-variant-7', {
          'icon-orientation-down': !disclosure.isOpen,
          'icon-orientation-up': disclosure.isOpen,
        })}
        {...disclosure.toggleProps}
      >
        <span className={buildClass('language-iso')}>
          {currentLanguage.toUpperCase()}
        </span>
        <span className={buildClass('language-full')}>
          {LANGUAGES[currentLanguage]}
        </span>
      </button>
      {disclosure.isOpen && (
        <div className="MenuMainItem__overlay" />
      )}
      <Dropdown
        id={LANGUAGE_SWITCHER_ID}
        ref={disclosure.targetRef}
        isOpen={disclosure.isOpen}
      >
        <ul className={buildClass('list')}>
          {Object.keys(LANGUAGES).map((langcode) => (
            <li
              className={buildClass('list-item')}
              key={`LanguageSwitcher-${langcode}`}
              aria-current={langcode === currentLanguage}
            >
              <button
                className={buildClass('language-button')}
                type="button"
                onClick={() => onLanguageChange(langcode)}
              >
                <span className={buildClass('language-iso')}>
                  {langcode.toUpperCase()}
                </span>
                <span className={buildClass('language-full')}>
                  {LANGUAGES[langcode]}
                </span>
              </button>
            </li>
          ))}
        </ul>
      </Dropdown>
    </div>
  );
};

export default LanguageSwitcher;
